/**
 * DropdownShell Component
 *
 * Shared dropdown container for toolbar selects.
 */

import type { ReactNode } from 'react';
import clsx from 'clsx';

export interface DropdownShellProps {
  children: ReactNode;
  widthClass?: string;
}

export function DropdownShell({
  children,
  widthClass = 'min-w-[200px] sm:min-w-[220px]',
}: DropdownShellProps) {
  return (
    <div
      className={clsx(
        'absolute z-50 mt-1.5 rounded-lg border border-border-primary/80 bg-surface-primary shadow-xl text-[11px]',
        widthClass
      )}
    >
      {children}
    </div>
  );
}
